import { useEffect, useState } from 'react';
import PortalIdParser from 'PortalIdParser';
const getStorageTypeString = isSession => isSession ? 'sessionStorage' : 'localStorage';
const getSetEventType = (key, isSession) => `set-${getStorageTypeString(isSession)}-${key}`;
const getStorage = isSession => isSession ? sessionStorage : localStorage;
const getItem = (key, logger, isSession) => {
  try {
    const item = getStorage(isSession).getItem(key);
    if (item === null) return null;
    const parsedItem = JSON.parse(item);
    return parsedItem;
  } catch (error) {
    logger.warn(`Failed to get item from ${getStorageTypeString(isSession)} with key: ${key}\nError: ${error}`);
    return null;
  }
};
const setItem = (key, value, logger, isSession) => {
  try {
    const stringifiedValue = JSON.stringify(value);
    getStorage(isSession).setItem(key, stringifiedValue);
    const eventType = getSetEventType(key, isSession);
    window.dispatchEvent(new Event(eventType));
  } catch (error) {
    logger.warn(`Failed to set item to ${getStorageTypeString(isSession)} with (key, value): (${key}, ${value})\nError: ${error}`);
  }
};
const useStorage = ({
  key,
  applicationId,
  logger,
  prefix = `hs-${applicationId}/${PortalIdParser.get()}/`,
  watch = true,
  isSession = false
}) => {
  const _key = `${prefix}${key}`;
  const [currentValue, setCurrentValue] = useState(getItem(_key, logger, isSession));
  useEffect(() => {
    if (watch) {
      const eventType = getSetEventType(_key, isSession);
      const listener = () => {
        setCurrentValue(getItem(_key, logger, isSession));
      };
      window.addEventListener(eventType, listener);
      return () => {
        window.removeEventListener(eventType, listener);
      };
    }
    return () => {};
  }, [watch, _key, logger, isSession]);
  return [currentValue, value => setItem(_key, value, logger, isSession)];
};
export default useStorage;